import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type OrderFormParamsServiceType = {
  payload: {
    companyId?: number
  }
}

export const orderFormParamsService = async ({
  payload, // 0 = parametros principais e quando tem valor != de 0, parametros da operacao que depende do cliente
}: OrderFormParamsServiceType): Promise<ResponseAPI> => {
  const response = await api.get(`tabelascadastro/${payload.companyId}`)

  return response.data
}
